/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { Form, Drawer, Button, Input, Select } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import {
  useFetchEventsByOrderId,
  useFetchOrdersById,
  useFetchOrdersEditedById,
  useStoreEditedOrders
} from "../../../app/orders/mutations";

import { TimeLine } from "./Timeline";
import { Alert } from "./Alert";
import useFetchMaster from "../../../app/maestro/mutations";
import { removeDuplicates } from "../../../utils/utils";
import "../../../styles/orders/ordenes.scss";
import { updateOrder } from "../../../app/orders/api";

import { EditableTable } from "./ProductsEditableTable";
import { ProductsTable } from "./ProductsTable";

import { useFilters } from "../../../app/orders/mutations";

const { TextArea } = Input;

export const OrdersDetail = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  let { data: master } = useFetchMaster();
  const { resetFilters } = useFilters();

  // const state = JSON.parse(localStorage.getItem("ORDERS_STORE"));

  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSendForm, setIsSendFrom] = useState(null);
  const [, setIsSendFormError] = useState(false);
  const [isOpenEvents, setIsOpenEvents] = useState(false);
  const [editedProducts, setEditedProducts] = useState(null);
  const [queryEvents, setQueryEvents] = useState(orderId);
  const [_events, setEvents] = useState(orderId);
  const query = useQueryClient();

  const order = useFetchOrdersById(orderId);
  const isEditedOrder = useFetchOrdersEditedById(orderId);

  const { events, refetch } = useFetchEventsByOrderId(queryEvents);

  useEffect(() => {
    setEvents(events);
  }, [events]);

  const handleEventsTimeline = (event) => {
    const selectedProduct = {
      posicion: event.posicion,
      id: event.orderId,
    };
    setQueryEvents(selectedProduct);

    setTimeout(() => {
      refetch();
    }, 200);
    setIsOpenEvents(true);
  };

  const onFinish = async (values) => {
    const {
      fechaPedido,
      observaciones,
      direccion,
      municipio,
      barrio,
      cedula,
      nombre,
      telefono,
      telefonoSecundario,
    } = values;

    setIsSendFormError(false);
    setIsSendFrom(false);

    let payload = {
      id: orderId,
      Cabecera: {
        FechaPedido: fechaPedido.replace(/-/g, ""),
        Observaciones: observaciones,
      },
      Direccion: {
        Direccion: direccion,
        Municipio: municipio,
        Barrio: barrio && barrio.length > 0 ? barrio : "",
        Cedula: cedula,
        Nombre: nombre,
        Telefono: `${telefono}|${telefonoSecundario}`,
      },
    };

    if (editedProducts) {
      payload.Detalle = [
        ...editedProducts.map((p) => {
          return {
            Posicion: p.posicion,
            Cantidad: p.cantidad,
            Costo: `${p.costo}|${p.costo}`,
            Tirrilla: p.tirilla,
            Referencia: p.referencia,
            FechaPromesa: p.fechaPromesa,
          };
        }),
      ];
    }

    await updateOrder(payload)
      .then((data) => {
        setIsSendFrom({ message: data, type: "success" });
        useStoreEditedOrders(payload.id);
      })
      .catch((e) => {
        setIsSendFrom({
          message: `Ocurrió un error: ${e.response.data.result}`,
          type: "error",
        });
      });
  };

  const handleOnConfirm = (editedProducts) => {
    setEditedProducts(editedProducts);
  };

  const handleReturn = () => {
    if (isSendForm) {
      navigate(-1);
    } else {
      navigate(-1);
    }
  };

  const storeCurrentOrder = (order) => {
    localStorage.setItem("CURRENT_ORDER", JSON.stringify(order));
  };

  storeCurrentOrder(order);

  return (
    <>
      <div className="orders">
        <div className="orders-header">
          <h2>Órdenes &gt; Editar</h2>
          <div className="orders-actions">
            <Button
              type="default"
              className="btn-secondary"
              onClick={handleReturn}
            >
              Volver
            </Button>
            {order && order.estado === "INCONSISTENCIA" && !isEditedOrder && (
              <Button
                form="orderDetailForm"
                key="submit"
                htmlType="submit"
                type="default"
                className="btn-primary"
                disabled={isSendForm && isSendForm.type === "success"}
              >
                Actualizar
              </Button>
            )}
          </div>
        </div>
        {order && (
          <div className="orders-detail-container">
            {isEditedOrder && <Alert message="Procesado exitosamente." type="success"/>}

            {((order.mensaje || isSendForm ) && !isEditedOrder) && (
              <div className="orders-table-header">
                <div className="table-header-messages">
                  {isSendForm && (
                    <Alert
                      message={isSendForm.message}
                      type={isSendForm.type}
                    />
                  )}
                  {!isSendForm && order.mensaje && (
                    <Alert message={order.mensaje} />
                  )}
                </div>
              </div>
            )}
            <div className="orders-form order-detail-form">
              <Form
                form={form}
                autoComplete="off"
                name="orderDetailForm"
                layout="vertical"
                onFinish={onFinish}
                initialValues={{
                  fechaPedido: order.fechaPedido,
                  cedula: order.cedula,
                  nombre: order.nombre,
                  telefono: order.telefono,
                  telefonoSecundario: order.telefonoSecundario,
                  barrio: order.barrio,
                  municipio: order.municipio,
                  direccion: order.direccion,
                  observaciones: order.observaciones,
                }}
              >
                <div className="form-row">
                  <Form.Item
                    name="ordenCompra"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Orden Compra"
                  >
                    <Input
                      type="text"
                      defaultValue={order.ordenCompra}
                      disabled={true}
                      size="medium"
                      title={order.ordenCompra}
                    />
                  </Form.Item>
                  <Form.Item
                    name="nombreCliente"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Cliente"
                  >
                    <Input
                      type="text"
                      defaultValue={order.nombreCliente}
                      disabled={true}
                      size="medium"
                      title={order.nombreCliente}
                    />
                  </Form.Item>
                  <Form.Item
                    name="puntoVenta"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Punto de Venta"
                  >
                    <Input
                      type="text"
                      defaultValue={order.puntoVenta}
                      disabled={true}
                      size="medium"
                      title={order.puntoVenta}
                    />
                  </Form.Item>
                  <Form.Item
                    name="solicitante"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Solicitante"
                  >
                    <Input
                      type="text"
                      defaultValue={order.solicitante}
                      disabled={true}
                      size="medium"
                      title={order.solicitante}
                    />
                  </Form.Item>
                </div>
                <div className="form-row">
                  <Form.Item
                    name="fechaPedido"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Fecha Pedido"
                  >
                    <Input
                      prefix={<CalendarOutlined style={{ fontSize: 24 }} />}
                      type="text"
                      disabled={order.estado !== "INCONSISTENCIA"}
                      size="medium"
                      title={order.fechaPedido}
                    />
                  </Form.Item>
                  <Form.Item
                    name="fechaPromesa"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Fecha Promesa"
                  >
                    <Input
                      prefix={<CalendarOutlined style={{ fontSize: 24 }} />}
                      type="text"
                      defaultValue={order.fechaPromesa}
                      disabled={true}
                      size="medium"
                      title={order.fechaPromesa}
                    />
                  </Form.Item>
                  <Form.Item></Form.Item>
                  <Form.Item></Form.Item>
                </div>
                <h2 className="header-green">Datos del usuario</h2>

                <div className="form-row">
                  <Form.Item
                    name="cedula"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Identificación"
                  >
                    <Input
                      type="text"
                      disabled={order.estado !== "INCONSISTENCIA"}
                      size="medium"
                      title={order.cedula}
                    />
                  </Form.Item>
                  <Form.Item
                    name="nombre"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Nombre Completo"
                  >
                    <Input
                      type="text"
                      disabled={order.estado !== "INCONSISTENCIA"}
                      size="medium"
                      showCount
                    />
                  </Form.Item>
                  <Form.Item
                    name="telefono"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Teléfono Principal"
                  >
                    <Input
                      type="text"
                      disabled={order.estado !== "INCONSISTENCIA"}
                      size="medium"
                      title={order.telefono}
                    />
                  </Form.Item>
                  <Form.Item
                    name="telefonoSecundario"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Teléfono Secundario"
                  >
                    <Input
                      type="text"
                      disabled={order.estado !== "INCONSISTENCIA"}
                      size="medium"
                      title={order.telefonoSecundario}
                    />
                  </Form.Item>
                </div>
                <div className="form-row">
                  <Form.Item
                    name="barrio"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Barrio"
                  >
                    <Input
                      type="text"
                      disabled={order.estado !== "INCONSISTENCIA"}
                      size="medium"
                      maxLength={40}
                      showCount
                      title={order.barrio}
                    />
                  </Form.Item>
                  <Form.Item
                    name="municipio"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Municipio"
                  >
                    <Select
                      showSearch
                      size="medium"
                      placeholder="Seleccione"
                      disabled={order.estado !== "INCONSISTENCIA"}
                      allowClear={true}
                      title={order.municipio}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={[
                        ...removeDuplicates(
                          master?.municipios.map(
                            (m) => `${m.codigoSAP}-${m.municipio}`
                          )
                        ).map((p, index) => {
                          return {
                            value: `${p}`,
                            label: `${p.toUpperCase()}`,
                          };
                        }),
                      ]}
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ flex: 2 }}
                    name="direccion"
                    rules={[{ required: false, message: "requerido" }]}
                    label="Dirección"
                  >
                    <TextArea
                      rows={2}
                      showCount
                      maxLength={60}
                      disabled={order.estado !== "INCONSISTENCIA"}
                    />
                  </Form.Item>
                </div>

                <div className="form-row">
                  <Form.Item
                    name="observaciones"
                    rules={[{ required: false, message: "requerido" }]}
                    className="text-area-control"
                    label="Observaciones"
                  >
                    <TextArea
                      rows={4}
                      showCount
                      disabled={order.estado !== "INCONSISTENCIA"}
                    />
                  </Form.Item>
                </div>
              </Form>
            </div>
            <h2 className="header-green">Productos</h2>
            <div className="orders-table-content">
              {/** <Table columns={columns} dataSource={order.productos} /> **/}

              {order.estado === "INCONSISTENCIA" && (
                <EditableTable
                  dataSource={order.productos}
                  onHandleEvent={handleEventsTimeline}
                  onConfirm={handleOnConfirm}
                  enabledToEdit={
                    order.estado !== "INCONSISTENCIA" ? true : false
                  }
                />
              )}
              {order.estado !== "INCONSISTENCIA" && (
                <ProductsTable
                  dataSource={order.productos}
                  onHandleEvent={handleEventsTimeline}
                  onConfirm={handleOnConfirm}
                  enabledToEdit={
                    order.estado !== "INCONSISTENCIA" ? true : false
                  }
                />
              )}
            </div>
          </div>
        )}
      </div>

      <Drawer
        title="Eventos"
        placement="right"
        onClose={() => setIsOpenEvents(!isOpenEvents)}
        open={isOpenEvents}
      >
        <TimeLine events={_events} />
      </Drawer>
    </>
  );
};
